// Presentation Component Library — the storytelling building blocks.
// Each export is a self-contained slide template. Defaults render placeholder
// content so the component can be dropped into any chapter without props.

export { SlideFrame, SlideHeader, Reveal } from "./SlideFrame";

export { HeroSlide } from "./HeroSlide";
export { ResearchSlide } from "./ResearchSlide";
export { ObservationSlide } from "./ObservationSlide";
export { ComparisonSlide } from "./ComparisonSlide";
export { ProductWalkthroughSlide } from "./ProductWalkthroughSlide";
export { MetricsDashboardSlide } from "./MetricsDashboardSlide";
export { TimelineSlide } from "./TimelineSlide";
export { QuoteSlide } from "./QuoteSlide";
export { BusinessModelSlide } from "./BusinessModelSlide";
export { FounderSlide } from "./FounderSlide";
export { ClosingSlide } from "./ClosingSlide";

// Catalogue used by the design-system showcase and (later) by chapter
// authoring to pick a slide template by id.
export const SLIDE_CATALOGUE = [
  { id: "hero",                title: "Hero Statement",      description: "Single big idea + large visual + continue." },
  { id: "research",             title: "Research / Evidence", description: "Finding + chart + callout + source." },
  { id: "observation",          title: "Observation",         description: "Market observation + comparison + insight." },
  { id: "comparison",           title: "Comparison",          description: "Side-by-side or before/after framing." },
  { id: "product-walkthrough",  title: "Product Walkthrough", description: "Device frame + screen carousel." },
  { id: "metrics-dashboard",    title: "Metrics Dashboard",   description: "KPIs + chart + supporting insight." },
  { id: "timeline",             title: "Timeline / Roadmap",  description: "Milestones + progress rail." },
  { id: "quote",                title: "Quote / Testimonial", description: "Large quotation with attribution." },
  { id: "business-model",       title: "Business Model",      description: "Value flow + pricing + unit economics." },
  { id: "founder",              title: "Founder",             description: "Portrait + timeline + narrative." },
  { id: "closing",              title: "Closing",             description: "Headline + CTA + contact + handoff." },
];
